// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__371yK","label":"Category_label__37OgY","content":"Category_content__35e-y","header":"Category_header__1PqUz","location":"Category_location__3L69z"};